/* eslint-disable no-param-reassign */

import Cookies from 'js-cookie';
import Modal from './modal';
import { $, $$ } from '../helper/utils';
import { PHONEMEDIA } from '../helper/constants';
import '../../libs/gsap-plugins/DrawSVGPlugin';

const agegate = $('.agegate');
const ageInput = $$('.age-input');
const yearInput = $$('.year-input');
const dayInput = $$('.day-input');
const monthInput = $$('.month-input');
const checkAgeForm1 = $('.agegate-checkform');
const agegroup = $('.agegroup-extended');

function openModal(e) {
  e.preventDefault();

  if ('modal' in this === false) {
    const tm = Modal(this);
    this.modal.modal = tm;
  }

  this.modal.modal.show(e);
}

function setHtmlContent(el) {
  const endSlash = /(\/)$/g;
  let url = el.getAttribute('href');

  // add slash if url doesn't end with one but current document does
  if (endSlash.test(document.location.pathname) === true && endSlash.test(url) === false) {
    url += '/';
  }

  console.log(url);

  fetch(url)
    .then((response) => response.text())
    .then((html) => {
      const dummy = document.createElement('div');
      dummy.innerHTML = html;
      dummy.hidden = true;

      const content = dummy.querySelector('.content');
      if (content !== null) {
        el.setAttribute('data-text', content.innerHTML);
      } else {
        el.removeEventListener('click', openModal);
      }
    })
    .catch(() => {
      el.removeEventListener('click', openModal);
    });
}

const modals = $$('.text-modal');
if (modals.length > 0) {
  for (let i = 0; i < modals.length; i++) {
    const el = modals[i];
    setHtmlContent(el);
    el.addEventListener('click', openModal);
  }

  // close modals on escape key press
  window.addEventListener('keyup', (e) => {
    if (e.keyCode === 27) {
      for (let i = 0; i < modals.length; i++) {
        const m = modals[i];
        if ('modal' in m && m.modal.open === true) {
          m.modal.modal.close();
        }
      }
    }
  });
}

function formTween(form) {
  if (!form) {
    form = $('.agegate .agegate-checkform');
  }

  form.classList.add('active');
  const checkAgeField = form.querySelector('.check-age');
  const formDiv = form.querySelector('.input-group');
  const lock = form.querySelector('.lock');
  const bracket = form.querySelector('.bracket');

  if (PHONEMEDIA.matches) {
    document.documentElement.classList.remove('noscroll');
    TweenMax.set(agegate, { display: 'none' });
    return;
  }

  const first = checkAgeField.getBoundingClientRect();
  TweenMax.set(checkAgeField, { left: 'calc(50% - 52px)', x: 0 });
  const last = checkAgeField.getBoundingClientRect();
  const invertX = first.left - last.left;
  TweenMax.set(checkAgeField, { x: invertX });
  const tl = new TimelineMax({ delay: 0.25 });
  tl.to(checkAgeField, 0.75, { x: -13 })
    .to(formDiv, 0.75, { xPercent: -100 }, '-=.75')
    .to(bracket, 0.25, { drawSVG: '22% 100%' })
    .to(bracket, 0.5, { opacity: 0 }, '+=.3')
    .to(lock, 0.5, { yPercent: -28 }, '-=.5')
    .eventCallback('onComplete', () => {
      document.documentElement.classList.remove('noscroll');
      TweenMax.set(agegate, { display: 'none' });
    });
}

function getYearAge(fields) {
  let year = '';
  let yearfull = true;
  for (let i = 0; i < fields.length; i++) {
    const val = fields[i].value;
    if (val === '' || val < 0 || val > 9) {
      yearfull = false;
    } else {
      year += val;
    }
  }

  return yearfull && year;
}

function getDayMonth(dayfields, monthFields) {
  let day = '';
  let month = '';
  let daymonthfull = true;
  for (let i = 0; i < dayfields.length; i++) {
    const val = dayInput[i].value;
    if (val === '' || val < 0 || val > 9) {
      daymonthfull = false;
    } else {
      day += val;
    }
  }

  for (let i = 0; i < monthFields.length; i++) {
    const val = monthInput[i].value;
    if (val === '' || val < 0 || val > 9) {
      daymonthfull = false;
    } else {
      month += val;
    }
  }

  return daymonthfull ? { day: parseInt(day, 10), month: parseInt(month, 10) } : false;
}

function checkAge(form, year) {
  if (year !== false) {
    const today = new Date();
    const age = today.getFullYear() - parseInt(year, 10);

    if (age === 18) {
      agegroup.removeAttribute('hidden');

      const dayMonth = getDayMonth(dayInput, monthInput);
      if (dayMonth === false) {
        form.classList.remove('active');
        return;
      }

      const { day, month } = dayMonth;

      // check if month and day values are in a somewhat valid range
      if (
        month < 0
        || month > 12
        || (month === 2 && day > 29)
        || day < 0
        || day > 31
      ) {
        form.classList.remove('active');
        return;
      }

      const currentMonth = today.getMonth() + 1;
      const currentDay = today.getDate();

      // check if month or month and day haven't passed yet
      if (
        currentMonth - month < 0
        || (currentMonth - month === 0 && currentDay - day < 0)
      ) {
        return;
      }

      agegroup.setAttribute('hidden', '');
      form.classList.add('active');
      const remember = form.querySelector('.remember-me');
      if (remember !== null && remember.checked) {
        Cookies.set('rememberage', age, { expires: 14 });
        formTween();
      } else {
        formTween();
      }
      ajaxRequest(age, form)
    } else if (age > 18) {
      agegroup.setAttribute('hidden', '');
      form.classList.add('active');
      const remember = form.querySelector('.remember-me');
      if (remember !== null && remember.checked) {
        Cookies.set('rememberage', age, { expires: 14 });
        formTween();
      } else {
        formTween();
      }
      ajaxRequest(age, form)
    }
  } else if (form.classList.contains('active')) {
    agegroup.setAttribute('hidden', '');
    form.classList.remove('active');
  }
}

/**
 *
 * @param urls
 */
function createIFrames(urls) {
  const container = document.querySelector('.sc_agegate');
  container.innerHTML = '';
  for (let i = 0; i < urls.length; i++) {
    const iframe = document.createElement('iframe');
    iframe.src = urls[i];
    container.appendChild(iframe);
  }
}

function ajaxRequest(age, form) {
  const request = new XMLHttpRequest();
  const mode = form.querySelector('.mode').value;
  const url = window.location.origin.replace(/\/$/g, '');
  const lang = document.documentElement.lang || 'en';
  const remember = form.querySelector('.remember-me').checked;
  const requestUrl = url + '/veo/ajaxRequest.php';
  const requestData = {
    ajax: 1,
    c: 'RkViaHZ1UU5peVBqRUc2bTJyVTZPd2h0cHR5Y24xUlJHcHYxSWZRQ3g2N1A2RGJvSy9WaU5aZXpRK2NHQXlzVnVqa29PMDJsT3JNRjRpTk15cGdDamc9PQ==',
    m: 'YVlXVlNxWnl2aU9JdmV0c0psZFZhZz09',
    l: lang,
    dev: 1,
    se: 1
  };
  
  request.onload = function (e) {
    if (e.currentTarget.readyState === 4 && e.currentTarget.status === 200) {
      if (e.currentTarget.response) {
        let status = JSON.parse(e.currentTarget.response);
        if (status.status === 'success') {
          if (status.urls !== 'undefined') {
            createIFrames(status.urls);
          }
          formTween(form);
        }
      }
    }
  };
  
  if (!request) {
    console.error('Giving up :( Cannot create an XMLHTTP instance');
    return false;
  }
  
  request.open('POST', requestUrl);
  request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
  
  if (typeof mode !== 'undefined' && mode !== '') {
    requestData.mode = mode;
    requestData.age = age;
    requestData.remember = remember;
    const query = queryString(requestData, false);
    
    request.send(query);
  } else {
    console.info('mode must be set');
  }
}

/**
 * Create a query string from an object
 *
 * @param {object} params
 * @returns {string}
 */
function queryString (params, q = true) {
  let query = q ? '?' : '';
  return query + Object.keys(params)
    .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
    .join('&');
}

function checkField(field, fields, form) {
  const { value } = field;

  if (value.length > 1) {
    field.value = value.substring(1, 0);
    if (field.nextElementSibling) {
      field.nextElementSibling.value = value.substring(2, 1);
    }
  }
  if (value.length === 1) {
    if (field.nextElementSibling) {
      field.nextElementSibling.focus();
    }
  }
  if (value.length === 0) {
    if (field.previousElementSibling) {
      field.previousElementSibling.focus();
    }
  }

  const year = getYearAge(yearInput);

  if (year !== false && field.classList.contains('year-input')) {
    requestAnimationFrame(() => {
      agegroup.querySelector('input').focus();
    });
  }

  checkAge(form, year);
}

export default () => {
  // disable scrolling for background elements
  document.documentElement.classList.add('noscroll');

  const inputEvent = document.documentElement.classList.contains('ie') ? 'keyup' : 'input';

  for (let i = 0; i < ageInput.length; i++) {
    // reset last 2 fields incase they were prefilled by the browser back cache
    if (i > 1) {
      // console.log(ageInput[i]);

      ageInput[i].value = '';
    }

    ageInput[i].addEventListener(inputEvent, (e) => {
      if (e.key && (e.key === 'Shift' || e.key === 'Tab')) {
        return;
      }

      checkField(e.target, ageInput, checkAgeForm1);
    });
  }
};